import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const {
  configurationBegin,
  configurationSuccess,
  configurationErr

} = actions;

const getConfigurationAPI = '/admin/feature-configuration';
const updateConfigurationAPI = '/admin/feature-configuration-update';

const getConfigurationDetails = (values) => {
  return async (dispatch) => {
    dispatch(configurationBegin());
    try {
      const response = await DataService.get(getConfigurationAPI + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(configurationErr(response?.data?.message));
      } else {
        dispatch(configurationSuccess(response?.data?.result));
      }
      return response?.data;
    } catch (err) {
      dispatch(configurationErr(err));
    }
  };
};

const updateConfiguration = (values) => {
  return async (dispatch) => {
    dispatch(configurationBegin());
    try {
      const response = await DataService.post(updateConfigurationAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(configurationErr(response?.data?.message));
      } else {
        dispatch(configurationSuccess(response?.data?.result));
      }
      return response?.data;
    } catch (err) {
      dispatch(configurationErr(err));
    }
  };
};


export { getConfigurationDetails, updateConfiguration };
